export const passwordMinLength = 8;
